@if (appSettings.isMobile()) {
  <button type="button" class="form-select sheet-select-trigger"
    [class.text-muted]="!displayLabel()"
    [class.is-open]="inlineOpen()"
    [disabled]="disabled() || readonly()"
    (click)="openSheet()">
    {{ displayLabel() || placeholder() }}
  </button>

  @if (isNested() && inlineOpen()) {
    <div class="sheet-select-inline">
      @if (searchable()) {
        <div class="bottom-sheet-search px-0">
          <input type="search" class="form-control form-control-sm" placeholder="Buscar..."
            [ngModel]="query()" (ngModelChange)="query.set($event)"
            [ngModelOptions]="{standalone: true}">
        </div>
      }
      @if (clearable() && value() != null && value() !== '') {
        <button type="button" class="bottom-sheet-item bottom-sheet-link" (click)="clear()">
          Quitar selección
        </button>
      }
      @for (item of filteredItems(); track valueOf(item)) {
        <button type="button" class="bottom-sheet-item" [class.active]="isSelected(item)" (click)="pick(item)">
          <span class="bottom-sheet-item-title">{{ labelOf(item) }}</span>
        </button>
      } @empty {
        <div class="bottom-sheet-empty">Sin resultados</div>
      }
    </div>
  }

  @if (!isNested()) {
    <app-bottom-sheet [open]="open()" [title]="title() || placeholder()" (closed)="open.set(false)">
      @if (searchable()) {
        <div class="bottom-sheet-search">
          <input type="search" class="form-control" placeholder="Buscar..."
            [ngModel]="query()" (ngModelChange)="query.set($event)"
            [ngModelOptions]="{standalone: true}">
        </div>
      }
      @if (clearable() && value() != null && value() !== '') {
        <button type="button" class="bottom-sheet-item bottom-sheet-link" (click)="clear()">
          Quitar selección
        </button>
      }
      @for (item of filteredItems(); track valueOf(item)) {
        <button type="button" class="bottom-sheet-item" [class.active]="isSelected(item)" (click)="pick(item)">
          <span class="bottom-sheet-item-title">{{ labelOf(item) }}</span>
        </button>
      } @empty {
        <div class="bottom-sheet-empty">Sin resultados</div>
      }
    </app-bottom-sheet>
  }
} @else {
  <ng-select
    [items]="items()"
    [bindLabel]="bindLabel()"
    [bindValue]="bindValue() || undefined"
    [clearable]="clearable()"
    [searchable]="searchable()"
    [placeholder]="placeholder()"
    [readonly]="readonly() || disabled()"
    [ngModel]="value()"
    (ngModelChange)="onDesktopChange($event)"
    [ngModelOptions]="{standalone: true}">
  </ng-select>
}
